import script from "./textComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./textComponents.vue?vue&type=script&setup=true&lang=js"

import "./textComponents.vue?vue&type=style&index=0&id=72b308ac&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b308ac"]])

export default __exports__